import React, { Component } from 'react';
import { Result, Icon, WhiteSpace } from 'antd-mobile';

export default class RegisterSuccessed extends Component {
    constructor() {
        super()
      this.state = {
            height: null,
      }
    }
    
    componentDidMount() {
        let url = '/?g=mobile&c=user&a=success' // 普通微官网用户注册成功页面
        ///?g=mobile&c=coupon&a=apply 索尼用户注册成功后跳转到代金券申请
        if (this.props.source==='sony'){
            url = '/?g=mobile&c=coupon&a=apply'
        }
        setTimeout(function () {
            location.href = url
        },2000);
    }
    
    render() {
      let messageText = this.props.source==='sony'?"正在跳转至代金券领取页面…":'正在跳转至小程序引导页…';
        return (
            <div className="signin-success">
                <WhiteSpace />
                <Result
                    img={<Icon type="check-circle" className="success-icon" style={{ fill: '#1F90E6' }}/>}
                    title="注册成功"
                    message={messageText}
                />
                <WhiteSpace />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/register/register-successed.jsx